import React from "react";

const EmptyState = ({ icon, title, message, action, className = "" }) => {
  return (
    <div className={`bg-white rounded-lg shadow p-12 text-center ${className}`}>
      {icon && <div className="mb-4">{icon}</div>}

      {title && (
        <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      )}

      {message && <p className="text-gray-500 mb-4">{message}</p>}

      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
